import { Helmet } from "react-helmet-async";
import { SITE_URL, SITE_NAME } from "../lib/seo";

/**
 * Organization + LocalBusiness JSON-LD.
 * Mounted once at the app root — appears in the <head> of every rendered page.
 *
 * NOTE: Only verified facts from the site/footer are included.
 * Street address is intentionally omitted until confirmed by the client.
 */
const StructuredData = () => {
    const data = {
        "@context": "https://schema.org",
        "@type": "GeneralContractor",
        "@id": `${SITE_URL}/#organization`,
        name: SITE_NAME,
        alternateName: "MM Byggeri",
        url: SITE_URL,
        email: "mm@mmbr.dk",
        telephone: "+45 29 36 91 65",
        areaServed: [
            { "@type": "AdministrativeArea", name: "København" },
            { "@type": "AdministrativeArea", name: "Nordsjælland" },
        ],
        sameAs: [
            "https://www.instagram.com/mm_byggeri_og_radgivning/",
        ],
        description:
            "Eksklusivt byggeri, totalrenovering, snedkerarbejde og rådgivning for design- og kvalitetsbevidste bygherrer i København og Nordsjælland.",
        logo: `${SITE_URL}/favicon.svg`,
        image: `${SITE_URL}/favicon.svg`,
    };

    return (
        <Helmet>
            <script type="application/ld+json">{JSON.stringify(data)}</script>
        </Helmet>
    );
};

export default StructuredData;
